// Standard country name list — matches the format Shopify's customer address
// fields expect (e.g. "United States", not "US"). Used as a one-click quick-fill
// for select fields on registration/address forms.
export const COUNTRY_NAMES: string[] = [
  "United States", "Canada", "United Kingdom", "Australia", "New Zealand",
  "Ireland", "Germany", "France", "Italy", "Spain", "Portugal", "Netherlands",
  "Belgium", "Luxembourg", "Switzerland", "Austria", "Sweden", "Norway",
  "Denmark", "Finland", "Iceland", "Poland", "Czech Republic", "Slovakia",
  "Hungary", "Romania", "Bulgaria", "Greece", "Croatia", "Slovenia", "Serbia",
  "Bosnia and Herzegovina", "Albania", "North Macedonia", "Montenegro",
  "Estonia", "Latvia", "Lithuania", "Ukraine", "Belarus", "Moldova", "Russia",
  "Turkey", "Cyprus", "Malta", "India", "Pakistan", "Bangladesh", "Sri Lanka",
  "Nepal", "China", "Japan", "South Korea", "North Korea", "Taiwan",
  "Hong Kong", "Macau", "Mongolia", "Vietnam", "Thailand", "Cambodia", "Laos",
  "Myanmar", "Malaysia", "Singapore", "Indonesia", "Philippines", "Brunei",
  "Timor-Leste", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait",
  "Bahrain", "Oman", "Yemen", "Jordan", "Lebanon", "Israel", "Palestine",
  "Iraq", "Iran", "Syria", "Afghanistan", "Kazakhstan", "Uzbekistan",
  "Turkmenistan", "Tajikistan", "Kyrgyzstan", "Azerbaijan", "Armenia",
  "Georgia", "Egypt", "Libya", "Tunisia", "Algeria", "Morocco", "Sudan",
  "South Sudan", "Ethiopia", "Eritrea", "Djibouti", "Somalia", "Kenya",
  "Uganda", "Tanzania", "Rwanda", "Burundi", "Democratic Republic of the Congo",
  "Republic of the Congo", "Central African Republic", "Cameroon", "Chad",
  "Niger", "Nigeria", "Benin", "Togo", "Ghana", "Ivory Coast", "Liberia",
  "Sierra Leone", "Guinea", "Guinea-Bissau", "Senegal", "Gambia",
  "Mauritania", "Mali", "Burkina Faso", "South Africa", "Namibia", "Botswana",
  "Zimbabwe", "Zambia", "Malawi", "Mozambique", "Madagascar", "Mauritius",
  "Seychelles", "Comoros", "Angola", "Gabon", "Equatorial Guinea",
  "Sao Tome and Principe", "Eswatini", "Lesotho", "Mexico", "Guatemala",
  "Belize", "Honduras", "El Salvador", "Nicaragua", "Costa Rica", "Panama",
  "Cuba", "Jamaica", "Haiti", "Dominican Republic", "Bahamas",
  "Trinidad and Tobago", "Barbados", "Saint Lucia", "Grenada",
  "Saint Vincent and the Grenadines", "Antigua and Barbuda",
  "Saint Kitts and Nevis", "Dominica", "Brazil", "Argentina", "Chile",
  "Peru", "Colombia", "Venezuela", "Ecuador", "Bolivia", "Paraguay",
  "Uruguay", "Guyana", "Suriname", "Fiji", "Papua New Guinea",
  "Solomon Islands", "Vanuatu", "Samoa", "Tonga", "Kiribati",
  "Micronesia", "Marshall Islands", "Palau", "Nauru", "Tuvalu",
];
